import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import PageMeta from "./PageMeta";

const officers = [
  { role: "President", name: "John Munday" },
  { role: "Chairman", name: "Mark Kaczmarek" },
  { role: "Vice Chairman", name: "Chris Longman" },
  { role: "Hon. Secretary", name: "Tim Clotworthy" },
  { role: "Hon.Treasurer", name: "Graeme Hicks" },
  {
    role: "Fish Recorder",
    name: "Chris Wills",
    whatsapp: "447771646872",
    address: "Sea View, Treskerby, Redruth, TR15 1RG",
  },
  {
    role: "Assistant Fish Recorder",
    name: "Brian Collick",
    phone: "01209 217617 / 07759 332750",
    address: "4 Agar Road, Illogan Highway, TR15 3NA",
  },
  { role: "Shore Competition Secretary", name: "Brian Collick" },
  { role: "Boat Competition Secretary", name: "Edward Hicks" },
  { role: "Youth Officer", name: "Simon Thomas" },
  { role: "Welfare Officer", name: "Nick Ward" },
  { role: "Cup Custodian", name: "" },
  { role: "Social Media Secretary", name: "Graeme Hicks" },
  { role: "Conservation Officer", name: "Brian Collick" },
  { role: "Webmaster", name: "Andrew Searle" },
];

export default function OfficersPage() {
  const navigate = useNavigate();

  return (
    <div className="page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <PageMeta
        title="Club Officers | Redruth Sea Angling Association"
        description="Meet the committee and officers of Redruth Sea Angling Association, Cornwall's sea angling club since 1962."
        keywords="RSAA officers, sea angling club committee Cornwall, Redruth Sea Angling Association officers"
        url="https://www.redruthseaanglingassociation.co.uk/officers"
      />
      <div className="mx-auto max-w-4xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="mb-8 flex items-center gap-4">
          <button type="button" onClick={() => navigate(-1)}
            className="standalone-only group inline-flex items-center gap-1.5 rounded-full border border-cyan-400/20 bg-white/5 px-4 py-2 text-sm font-medium text-slate-200 shadow-lg shadow-black/20 backdrop-blur transition hover:-translate-x-0.5 hover:border-cyan-300/40 hover:bg-cyan-400/10 hover:text-white">
            ← Back
          </button>
          <div>
            <h1 className="heading-glow text-2xl font-bold text-white sm:text-3xl">Club Officers</h1>
          </div>
        </div>

        <p className="text-sm font-semibold uppercase tracking-[0.3em] text-cyan-300">Club officers</p>
        <h2 className="mt-4 text-3xl font-bold tracking-tight text-white sm:text-4xl">RSAA Club Officers</h2>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {officers.map(({ role, name, phone, whatsapp, address }) => (
            <div key={role} className="rounded-[1.6rem] border border-white/10 bg-white/5 p-5 panel-lift">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-300">{role}</p>
              <p className="mt-1 text-sm font-medium text-white">{name}</p>
              {phone && <p className="mt-2 text-sm text-slate-300">{phone}</p>}
              {whatsapp && (
                <a
                  href={`https://wa.me/${whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-2 flex items-center gap-1.5 text-sm text-cyan-300 transition hover:text-cyan-200"
                >
                  <MessageCircle className="h-4 w-4" /> Contact via WhatsApp
                </a>
              )}
              {address && <p className="text-sm text-slate-400">{address}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
